import React from "react";
import { observer } from "mobx-react";
import { Card, Paper, Table, Text, Box } from "@mantine/core";
import { Cubby } from "../../stores/Cubby";
import {
  IconBolt,
  IconBoltFilled,
  IconClock,
  IconCoinBitcoinFilled,
} from "@tabler/icons-react";
import ShowBalanceRow from "./showBalanceRow";
import { ARTICLES } from "../../docs/docsIndex";

const Balances = observer(({ cubby }: { cubby: Cubby }) => {
  return (
    <Card
      shadow="sm"
      padding="xs"
      radius="md"
      withBorder
      style={{ position: "relative" }}
    >
      <Table>
        <tbody>
          <ShowBalanceRow
            icon={IconCoinBitcoinFilled}
            label="BTC"
            amount={cubby.safeChainBalance}
            cubby={cubby}
            articleSlug={ARTICLES.BTC_BALANCE.slug}
          />
          {cubby.safePendingChainBalance > 0 && (
            <ShowBalanceRow
              icon={IconClock}
              label="Pending BTC"
              amount={cubby.safePendingChainBalance}
              cubby={cubby}
              articleSlug={ARTICLES.PENDING_BALANCE.slug}
            />
          )}
          <ShowBalanceRow
            icon={IconBoltFilled}
            label="Outbound"
            amount={cubby.outboundLiquidity}
            cubby={cubby}
            articleSlug={ARTICLES.OUTBOUND_BALANCE.slug}
          />
          <ShowBalanceRow
            icon={IconBolt}
            label="Inbound"
            amount={cubby.inboundLiquidity}
            cubby={cubby}
            articleSlug={ARTICLES.INBOUND_BALANCE.slug}
          />
        </tbody>
      </Table>
      <Box
        style={{
          position: "absolute",
          bottom: "0px",
          right: "12px",
        }}
      >
        {/* <Text size="xs" c="dimmed">
          testnet balances
        </Text> */}
      </Box>
    </Card>
  );
});

export default Balances;
